var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaskGroup8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 175,
    height: 84,
    viewBox: "0 0 175 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 84,
    height: 175,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8",
    "data-name": "Mask Group 8",
    transform: "translate(0 84) rotate(-90)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_213",
    "data-name": "Path 213",
    transform: "translate(-76 12)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5,0A75.5,75.5,0,1,1,0,75.5,75.5,75.5,0,0,1,75.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75.5 15 C 42.14019775390625 15 15 42.14019775390625 15 75.5 C 15 108.8598022460938 42.14019775390625 136 75.5 136 C 108.8598022460938 136 136 108.8598022460938 136 75.5 C 136 42.14019775390625 108.8598022460938 15 75.5 15 M 75.5 0 C 117.1974945068359 0 151 33.80249786376953 151 75.5 C 151 117.1974945068359 117.1974945068359 151 75.5 151 C 33.80249786376953 151 0 117.1974945068359 0 75.5 C 0 33.80249786376953 33.80249786376953 0 75.5 0 Z",
    stroke: "none",
    fill: "#ceee36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup8);
export default __webpack_public_path__ + "static/media/Mask Group 8.464eab8e789b936b38d02c8f35f5a707.svg";
export { ForwardRef as ReactComponent };